export const telegramLogMessageFormat = (params: Record<string, string | number>): string =>
  Object.entries(params)
    .map(([key, value]) => `*${key}*: ${value}`)
    .join('\n')
